// Web Vitals reporting utility
// Sends LCP, CLS, INP metrics via Beacon to a placeholder endpoint (to be implemented)
// Extend with FID/FCP if needed. Endpoint can be swapped for analytics provider.
import { onLCP, onCLS, onINP } from 'web-vitals';

function sendMetric(metric) {
  try {
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
      navigationType: metric.navigationType
    });
    // Replace '/analytics' with actual endpoint or third-party collector
    navigator.sendBeacon('/analytics', body);
  } catch (e) {
    // Fail silently; logging optional
    // console.warn('Web Vitals beacon failed', e);
  }
}

export function initWebVitals() {
  onLCP(sendMetric);
  onCLS(sendMetric);
  onINP(sendMetric);
}
